import { Box, Stack, Typography, Modal, Card } from "@mui/material";
import { useState } from "react";
import EditPreviewText from "./EditPreviewText";
import EditPreviewVideo from "./EditPreviewVideo";

export default function ArtistProfile() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  return (
    <Card sx={{ p: 3, borderRadius: "25px" }}>
      <Stack direction="column">
        <Typography variant="h6">Preview Video</Typography>
        <Typography variant="caption" color="text.secondary">
          Pinned on your feed for unsubscribed fans.{" "}
          <span
            onClick={(e) => {
              e.preventDefault();
              handleOpenModal();
            }}
            style={{ cursor: "pointer", color: "#04FFFF" }}
          >
            Example
          </span>
        </Typography>

        <EditPreviewVideo />
        <EditPreviewText />
      </Stack>

      <Modal
        open={isModalOpen}
        onClose={handleCloseModal}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            bgcolor: "background.paper",
            boxShadow: 24,
            // p: 20,
            maxWidth: "90vw",
            maxHeight: "90vh",
            outline: "none",
            borderRadius: "20px",
          }}
        >
          <video
            controls
            autoPlay
            style={{
              maxWidth: "100%",
              maxHeight: "500px",
              borderRadius: "20px",
            }}
            src="https://storage.googleapis.com/notebook-fm-cdn-prod/4ba9d1c2-501f-42ad-8c26-b4d63be9cf40"
          />
        </Box>
      </Modal>
    </Card>
  );
}
